export enum GlobalAccess {
  WRITE = "WRITE",
  READ = "READ",
  NONE = "NONE",
}

export type GlobalAccessType = GlobalAccess | keyof typeof GlobalAccess;
